module.exports = __webpack_public_path__ + "img/icons_UI_icon_X_auswertung.55ea19d0.svg";